import { ICommentsState } from '../interfaces/comments';
import { IGlobalState } from '../reducers';

export const getCurrentArticleComments = (articleId) => {
  return (state: IGlobalState): ICommentsState | undefined => state.comments[articleId];
};

export const getCommentsError = (articleId) => {
  return (state: IGlobalState): string => state.comments[articleId]?.error;
};

export const getCurrentArticleTotalComments = (articleId) => {
  return (state: IGlobalState): number | undefined => state.comments[articleId]?.total;
};
